import { useEffect } from 'react';
import {
  isSupportedLanguageCode,
  resolveBrowserLanguageCode,
} from 'src/lib/i18n';
import { loadLanguage } from 'src/lib/load-language';
import { useCurrentUserStore } from 'src/stores/useUserStore';

// Resolution order: stored user language -> browser locale -> German.
export function I18nProvider({ children }: React.PropsWithChildren) {
  const { currentUser } = useCurrentUserStore();

  useEffect(() => {
    void loadLanguage(resolveBrowserLanguageCode());
  }, []);

  useEffect(() => {
    if (!isSupportedLanguageCode(currentUser?.languageCode)) {
      return;
    }
    void loadLanguage(currentUser.languageCode);
  }, [currentUser?.languageCode]);

  return <>{children}</>;
}
